const SIDEBAR_COLLAPSED_KEY = "flipmail-sidebar-collapsed";

export function getInitialSidebarCollapsed() {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "1";
  } catch {
    return false;
  }
}

export function persistSidebarCollapsed(value) {
  try {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, value ? "1" : "0");
  } catch {
    /* ignore */
  }
}
